import React, { useState, useEffect, useRef } from "react";
import classes from "./BiddingScreen.module.css";
import RemainingTime from "./RemainingTime";
import Loader from "../../Shared/Loader";
// import axios from 'axios'
import Axios from "../../../Axios";
import { useAppContext } from "../../../Context/AppContext";
import { useLocation, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Urls } from "../../../Urls";
import {
  Activity,
  currentRequestTimeStamp,
  numberWithCommas,
  ActivityAuction,
  isMobile,
} from "../../../Constants";

import PopupWidget from "../../PopupWidget";
import mixpanel from "mixpanel-browser";
import AuctionChat from "../Chat/Chat";
import {
  auctionDetailsFromDB,
  checkBlockUnblock,
  db_time_stamp,
  getChats,
  titleCase,
  updateAuctionStatus,
  updateL1Quote,
  updateTransporterStatusInDB,
  updatedTime,
} from "../../../Utility";
import { decryptResponse } from "../../RateCard/utils";
import ConfirmDialog from "../../Shared/ConfirmDialog2/ConfirmDialog2";
import { useMixPanelForTracking } from "../../../shared_utilities/trackMixPanel";

const BiddingScreen = () => {
  const [transporterAccess, setTransporterAccess] = useState(false);
  const { transporterInfo,clientIp,showLoader } = useAppContext();
  const history = useHistory();
  const location = useLocation();

  const {TrackMixPanel} = useMixPanelForTracking()

  const [auctionDetails, setauctionDetails] = useState({});
  const [rank, setrank] = useState("");
  const [L1_Quote, setL1_Quote] = useState(0);
  const [bidAmount, setbidAmount] = useState(0);
  // const [number, setnumber] = useState(0)
  const [myBid, setmyBid] = useState(0);
  // const [finalOffer, setFinalOffer] = useState(false);
  const [TimerDate, setTimerDate] = useState();
  const [show, setShow] = useState(false);
  const [Bid_updated, setBid_updated] = useState();
  // const [autoExtension, setautoExtension] = useState(30)
  // const [Messages, setMessages] = useState([])
  const [auctionClosed, setauctionClosed] = useState(false);
  // const [isSyncing, setisSyncing] = useState(false)
  const [reload_timer, setreload_timer] = useState(false);
  const [starttime, setStarttime] = useState();
  const [scroll, setscroll] = useState("");
  const [showScroll, setshowScroll] = useState(false);
  const [showBlocked, setShowBlocked] = useState(false);
  const [auctionpaused, setAuctionpaused] = useState(false);
  const [paused_timestamp, setpaused_timestamp] = useState("");
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [userEmail, setUserEmail] = useState("");
  const [connection_msg_list, setconnection_msg_list] = useState([]);
  // const [receive, setReceive] = useState(false)
  const [buttonClassName, setButtonClassName] = useState("bg-colo");
  // const [showStatus, setShowStatus] = useState(false)
  const [offset, setOffset] = useState(0);
  const timeoutRef = useRef(null);
  const firstRunRef = useRef(true);
  const [timerKey, setTimerKey] = useState(0);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    message: "",
    onConfirm: () => {},
    variant: "default",
    title: "Are you sure?",
    disableButton: auctionClosed || auctionpaused,
  });

  const resetConfirmDialog = () => {
    setConfirmDialog({
      isOpen: false,
      message: "",
      onConfirm: () => {},
      variant: "default",
      disableButton: auctionClosed || auctionpaused,
    });
  };
  useEffect(() => {
    if (!showLoader && transporterInfo) {
      const email =
        transporterInfo?.contact_information?.length > 0 &&
        transporterInfo?.contact_information?.find(
          (i) => i?.name === transporterInfo?.transporter_name
        )?.email;
      setUserEmail(email);
    }
  }, [transporterInfo]);

  // The useEffect hook is executed once when the component mounts.
  useEffect(() => {
    // Fetches auction details from the database and updates the scroll and visibility state.
    if(transporterInfo?.transporter_id!==undefined){
      auctionDetailsFromDB(
        location.state.auction_id,
        setscroll,
        setshowScroll,
        transporterInfo?.transporter_id,
        setTransporterAccess
      );
    }

    // Checks whether the auction is blocked or unblocked and updates the blocked status.
    if(transporterInfo?.transporter_id!==undefined){
      checkBlockUnblock(
        location.state.auction_id,
        setShowBlocked,
        transporterInfo?.transporter_id,
        setTransporterAccess
      );
    }

    // Retrieves chat messages for the auction and updates the chat message list and button class.
    if(transporterInfo?.transporter_id!==undefined){
      getChats(
      location.state.auction_id,
      setconnection_msg_list,
      setButtonClassName,
      transporterInfo?.transporter_id,
      transporterInfo?.transporter_name,
      setTransporterAccess
    );
    }

    // Logs the user's activity of viewing the auction chat screen.
    Activity([
      {
        screen: "Auction Chat",
        module: "Auction Chat",
        user_activity: "Auction transporter Chat screen viewed",
        timestamp: currentRequestTimeStamp(), // Records the current timestamp
      },
    ]);

    // Tracks the event of the user clicking on the auction transporter chat button using Mixpanel.
    mixpanel.track(`User has clicked on Auction transporter Chat button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Procure",
      ModuleName: "auctions",
      ActivityLog: "userClickedChatButton",
      Data: `None`,
      Definition: `User has clicked on Auction transporter Chat button`,
      ActivityType: "event_view",
      UserName: transporterInfo?.transporter_name,
      UserEmail: userEmail,
    });

    // Updates the auction status and handles related state updates such as pausing the auction and reloading the timer.
    updateAuctionStatus(
      location.state.auction_id,
      setAuctionpaused,
      setauctionClosed,
      setreload_timer,
      reload_timer,
      setpaused_timestamp,
      getAuctionDetails,
      location.state.bucket,
      transporterInfo?.transporter_id
    );
  }, [transporterInfo]);

  useEffect(() => {
    if (auctionClosed || auctionpaused) {
      resetConfirmDialog();
    }
  }, [auctionClosed, auctionpaused]);

  // useEffect(() => {
  //   // If it's the first run, trigger the update immediately
  //   if (firstRunRef.current) {
  //     updatedTime(location.state.auction_id, setTimerDate);

  //     // Updates the database timestamp to reflect the current time.
  //     // This might be used to synchronize or log timestamps in the database.
  //     let startTime = new Date().getTime();
  //     db_time_stamp(setOffset, startTime);
  //     setreload_timer(!reload_timer); // Your function to handle database updates
  //     firstRunRef.current = false; // Mark that the first run has completed
  //     return; // Skip the debounce logic on the first run
  //   }

  //   // Clear the previous timeout if bid_list or isPaused changes quickly
  //   if (timeoutRef.current) {
  //     clearTimeout(timeoutRef.current);
  //   }

  //   // Set a new timeout to debounce the updates
  //   timeoutRef.current = setTimeout(() => {
  //     updatedTime(location.state.auction_id, setTimerDate);

  //     // Updates the database timestamp to reflect the current time.
  //     // This might be used to synchronize or log timestamps in the database.
  //     let startTime = new Date().getTime();
  //     db_time_stamp(setOffset, startTime);
  //     // setreload_timer(!reload_timer)    // Your function to handle database updates
  //   }, 1000); // Delay of 1 second

  //   // Cleanup function to clear the timeout when the component unmounts or dependencies change
  //   return () => {
  //     if (timeoutRef.current) {
  //       clearTimeout(timeoutRef.current);
  //     }
  //   };
  // }, [auctionpaused, L1_Quote]);

  useEffect(() => {
    if (isFirstRender) {
      updatedTime(
        location.state.auction_id,
        setTimerDate,
        transporterInfo?.transporter_id
      );
      let startTime = new Date().getTime();
      db_time_stamp(setOffset, startTime);
      setIsFirstRender(false);
    } else {
      if (auctionClosed === false) {
        const intervalId = setInterval(() => {
          updatedTime(
            location.state.auction_id,
            setTimerDate,
            transporterInfo?.transporter_id
          );
          let startTime = new Date().getTime();
          db_time_stamp(setOffset, startTime);
          setTimerKey(timerKey + 1);
        }, 20000);

        return () => {
          clearInterval(intervalId);
        };
      }
    }
  }, [auctionpaused, auctionClosed, isFirstRender, transporterInfo]);

  const getLiveTransporter = async(id,status) => {
    if((id===undefined || id===null || id==="") || !transporterAccess){
      return;
    }
    const payload = {
      status:status
    }
    try {
      await Axios.post(`${Urls.messages}/live_transporters?auction_id=${location.state.auction_id}`,payload)
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    let transporter_id = "";
    let transporter_name = "";
    let uid = "";
    if (transporterInfo) {
      transporter_id = transporterInfo?.transporter_id;
      transporter_name = transporterInfo?.transporter_name;
      uid = transporterInfo?.user_details?.user_id;
    }
    const handleExit = async() => {
      if (transporter_id && transporterAccess) {
       await getLiveTransporter(transporter_id, "exit");
      }
    };
  
    const handleEnter = async () => {
      if (transporter_id && transporterAccess) {
        await getLiveTransporter(transporter_id,"enter");
      }
    };
  
    async function init() {
      await handleEnter();
  
      window.addEventListener("beforeunload", handleExit);
      window.addEventListener("unload", handleExit);
  
      document.title = "Auction - Bidding Screen";
      setShow(true);
  
      const start = new Date();
      getAuctionDetails(start, location.state.bucket);
    }
  
    init(); // 🔁 Call async function
  
    return () => {
      window.removeEventListener("beforeunload", handleExit);
      window.removeEventListener("unload", handleExit);
      handleExit();
      resetConfirmDialog();
    };
  }, [transporterInfo, transporterAccess]);
  
  /**
   * Fetches auction details from the server and updates relevant states.
   * @param {Date} start - The start time for measuring request duration.
   * @param {string} bucket - The bucket parameter used in the request URL.
   */
  const getAuctionDetails = (start, bucket) => {
    if (
      transporterInfo?.transporter_id === undefined ||
      transporterInfo?.transporter_id === null ||
      transporterInfo?.transporter_id === ""
    ) {
      setShow(false);
      return;
    }
    // Check if the bucket parameter is provided.
    if (bucket) {
      // Make a GET request to fetch auction details.
      Axios.get(
        `${Urls.auction}?auction_id=${location.state.auction_id}&procurement_id=${location.state.procurement_id}&bucket=${bucket}`
      )
        .then((response) => {
          // Check if the response and response data are valid.
          if (response && response.data) {
            // Decrypt the response data.
            const res = {
              data: decryptResponse(response?.data),
            };
            // Update auction details state with the first auction in the response.
            setauctionDetails(res?.data?.auctions?.[0]);

            // Process ending time for the auction.
            endingTime(res.data?.auctions?.[0]);

            // Toggle the reload timer state.
            // setreload_timer(!reload_timer);

            // Update the L1 Quote and related states based on auction data.
            updateL1Quote(
              location.state.auction_id,
              setmyBid,
              setL1_Quote,
              setbidAmount,
              res.data.auctions?.[0]?.bid_decrement_amount,
              setrank,
              transporterInfo?.transporter_id,
              setBid_updated,
              setTimerDate,
              setreload_timer,
              reload_timer,
              myBid
              // setFinalOffer
            );

            // Update the database time stamp.
            //  let startTime = new Date().getTime()
            // db_time_stamp(setOffset, startTime);
            // setreload_timer(!reload_timer)
            // Hide the loading or placeholder display.
            setShow(false);

            // Measure the time taken for the request and display a message if it took too long.
            const timeTaken = new Date() - start;
            if (timeTaken >= 5000) {
              document.getElementById("internet-message").style.display =
                "block";
            }
          }
        })
        .catch((err) => {
          // Log any errors and hide the loading display.
          console.log(err);
          setShow(false);
        });
    }
  };

  /**
   * Calculates and sets the ending time of the auction based on the provided data.
   * @param {Object} data - The auction data object containing various timestamps and status.
   */
  const endingTime = (data) => {
    // Check if server timestamp is provided and set the start time accordingly.
    if (data?.server_timestamp) {
      setStarttime(new Date(data.server_timestamp));
    } else {
      setStarttime(Date()); // Default to current date if no server timestamp is available.
    }
  };

  /**
   * Decreases the current bid amount by the auction's bid decrement amount.
   * Updates the bid amount state based on the calculation.
   */
  const BidDecrement = () => {
    // Retrieve the current bid amount from state.
    const currentBidAmount = bidAmount;

    // Calculate the new bid amount by subtracting the bid decrement amount from the current bid amount.
    const newBidAmount =
      currentBidAmount - auctionDetails?.bid_decrement_amount;

    // Update the bid amount state.
    // If the new bid amount is greater than 0, set it to the new value; otherwise, set it to 0.
    if (newBidAmount > 0) {
      setbidAmount(newBidAmount);
    } else {
      setbidAmount(0);
    }
  };

  /**
   * Increments the current bid amount based on the auction's bid decrement amount.
   * Updates the bid amount state while ensuring it adheres to auction constraints.
   */
  const BidIncrement = () => {
    // Retrieve the current bid amount from state.
    const currentBidAmount = bidAmount;

    // Calculate the new bid amount by adding the bid decrement amount to the current bid amount.
    const newBidAmount =
      currentBidAmount + (auctionDetails?.bid_decrement_amount || 0);

    // If L1_Quote is zero, set bid amount based on starting amount.
    if (L1_Quote === 0) {
      // Ensure the new bid amount does not exceed the starting amount minus the bid decrement.
      if (
        newBidAmount <=
        auctionDetails?.starting_amount - auctionDetails?.bid_decrement_amount
      ) {
        setbidAmount(newBidAmount);
      } else {
        setbidAmount(auctionDetails?.starting_amount);
      }
    }
    // If L1_Quote is less than or equal to the bid decrement amount, no specific action is taken.
    if (L1_Quote <= auctionDetails?.bid_decrement_amount) {
      // No changes are made if the quote is less than or equal to the bid decrement amount.
      // This part is left empty as the original code didn't specify an action.
    }
    // Otherwise, increment the bid amount within the constraints of L1_Quote.
    else if (
      newBidAmount <= L1_Quote - auctionDetails?.bid_decrement_amount &&
      L1_Quote !== 0
    ) {
      setbidAmount(newBidAmount);
    } else {
      // Ensure the bid amount does not exceed L1_Quote minus the bid decrement amount.
      setbidAmount(L1_Quote - auctionDetails?.bid_decrement_amount);
    }
  };

  /**
   * Handles the bid submission process.
   * Validates bid conditions and sends the bid data if all checks pass.
   */
  const submitHandler = (isFinalOffer = false) => {
    if(transporterAccess===false){
      toast.error("Permission denied");
      return;
    }
    // do not alow bid in blocked or paused state
    if (showBlocked || auctionpaused) {
      return;
    }
    const isBidValid =
      bidAmount > 0 && // bid greater than zero
      !isNaN(bidAmount) && // number bid
      bidAmount !== undefined && // bid not undefined
      bidAmount !== null; // bid not null

    // Check if high_quote_percentage or low_quote_percentage is 0 or undefined
    const isHighQuote =
      auctionDetails?.high_quote_percentage &&
      auctionDetails?.high_quote_percentage !== 0
        ? bidAmount >
          auctionDetails?.baseline_rate *
            (1 + auctionDetails?.high_quote_percentage / 100)
        : false;

    const isLowQuote =
      auctionDetails?.low_quote_percentage &&
      auctionDetails?.low_quote_percentage !== 0
        ? bidAmount <
          auctionDetails?.baseline_rate *
            (1 - auctionDetails?.low_quote_percentage / 100)
        : false;

    // Validation
    const bidValidation = {
      isValid: isBidValid,
      isHighQuote: isHighQuote,
      isLowQuote: isLowQuote,
      isLowerThanL1:
        L1_Quote !== 0 &&
        bidAmount <= L1_Quote - auctionDetails?.bid_decrement_amount,
    };

    if (!bidValidation.isValid) {
      toast.error("Bid amount must be greater than 0");
      return;
    }

    if (L1_Quote !== 0 && !bidValidation.isLowerThanL1) {
      toast.error("Please enter a value lower than the L1 rate.");
      return;
    }

    const submitBid = () => {
      // Show loading indicator
      setShow(true);

      const payload = {
        user_id: transporterInfo?.user_details.user_id,
        auction_id: auctionDetails?.auction_id,
        transporter_id: transporterInfo?.transporter_id,
        transporter_name: transporterInfo?.transporter_name,
        bid_amount: parseInt(bidAmount, 10),
        ip: clientIp,
      };

      // Add final_rate if this is a final offer
      if (isFinalOffer) {
        payload.final_rate = true;
      }
      // Send the bid data to the server.
      Axios.post(`${Urls.messages}/messages`, payload)
        .then((res) => {
          // Hide loading indicator on success
          setShow(false);

          if (isFinalOffer) {
            toast.success("Final Offer Bid Submitted Successfully!!");
          } else {
            toast.success("Bid Submitted Successfully!!");
          }
        })
        .catch((err) => {
          console.error(err);
          // Hide loading indicator and show error message on failure
          setShow(false);
          toast.info("Bid unsuccessful. Please try again");
        });


        TrackMixPanel({
          Definition:isFinalOffer ? "user has clicked on the final offer button." : "user has clicked on the submit bid button.",
          ModuleName:"tpmp auction",
          ScreenName:"auctions - active auctions - bidding screen",
          Data:{
            "BidAmount":payload?.bid_amount,
            "AuctionId":auctionDetails?.auction_id,
            "AuctionDescription":auctionDetails?.auction_description,
            "ProcurementName":auctionDetails?.procurement_name
          }
        })

      // Log the user's activity using a custom Activity function
      // ActivityAuction(
      //   [
      //     {
      //       screen: "auction",
      //       module: "auction bidding screen",
      //       user_activity: `User clicked submit bid button ${bidAmount}`,
      //       timestamp: currentRequestTimeStamp(),
      //     },
      //   ],
      //   clientIp
      // );
    };

    // Show confirmation dialog based on conditions
    if (isFinalOffer) {
      setConfirmDialog({
        isOpen: true,
        title: "Final Offer Confirmation",
        message: (
          <div>
            Are you sure you want to submit this bid as your{" "}
            <strong>final offer</strong>?
          </div>
        ),
        onConfirm: submitBid,
        variant: "default",
      });
    } else if (bidValidation.isHighQuote) {
      setConfirmDialog({
        isOpen: true,
        title: "High Bid Confirmation",
        message: (
          <div>
            Bid amount is <b>higher</b> than the expected rate. Are you sure you
            want to submit this bid?
          </div>
        ),
        onConfirm: submitBid,
        variant: "danger",
      });
    } else if (bidValidation.isLowQuote) {
      setConfirmDialog({
        isOpen: true,
        title: "Low Bid Confirmation",
        message: (
          <div>
            Bid amount is <b>lower</b> than the expected rate. Are you sure you
            want to submit this bid?
          </div>
        ),
        onConfirm: submitBid,
        variant: "warning",
      });
    } else {
      setConfirmDialog({
        isOpen: true,
        title: "Confirm Bid",
        message: "Are you sure you want to submit this bid?",
        onConfirm: submitBid,
        variant: "default",
      });
    }
  };

  const trackExitAuction = (isBlocked = false) => {

    TrackMixPanel({
        Data:{
          "AuctionId":auctionDetails?.auction_id,
          "AuctionDescription":auctionDetails?.auction_description,
          "ProcurementName":auctionDetails?.procurement_name,
          "Type":auctionDetails?.type
        },
        Definition: isBlocked
          ? "user clicked go back to auction summary on blocked popup"
          : "User clicked go back to auction summary",
        ModuleName:"tpmp auction",
        ScreenName:`auctions - ${auctionDetails?.auction_status} auctions - bidding screen`
      })

  };

  const exitAuction = (isBlocked = false) => {
    trackExitAuction(isBlocked);
    if (isBlocked) {
      resetConfirmDialog();
      history.push({ pathname: "/auction" });
    } else {
      setConfirmDialog({
        isOpen: true,
        message: <div>Are you sure you want to exit the auction?</div>,
        // title: `Exit Auction - ${auctionDetails?.auction_description}`,
        title: `Exit Auction?`,
        variant: "default",
        onConfirm: () => {
          resetConfirmDialog();
          history.push({ pathname: "/auction" });
        },
        disableButton: false,
      });
    }
  };

  return (
    <div className={classes["container"]}>
      <Loader show={show} />
      <div id="internet-message" className={classes["internet-message"]}>
        <div className={classes["cross-button"]}>
          <i
            style={{ color: "#393186", cursor: "pointer" }}
            className="fa fa-times"
            onClick={(e) =>
              (document.getElementById("internet-message").style.display =
                "none")
            }
          ></i>
        </div>
        <br />
        <i
          style={{ color: "orange", fontSize: "xxx-large" }}
          className="fas fa-exclamation-triangle"
        ></i>
        <br />
        <div className={classes["message"]}>
          <span>
            <b>Your Internet connection is unstable. </b>
          </span>
          <span>
            <b>
              Please check your connection and refresh / rejoin the auction for
              seamless bidding experience.
            </b>
          </span>
        </div>
      </div>
      {showScroll ? (
        <div style={{ marginBottom: "6%" }} id="scroll">
          <p className={classes["marquee"]}>
            <span style={{ fontSize: "20px" }}>{scroll}&nbsp;</span>
          </p>
        </div>
      ) : null}
      {showBlocked ? (
        <div className={classes["main-block"]}>
          <div id={"blocked-popup"} className={classes["block"]}>
            <br />
            <h5>
              <b>You are no longer allowed to bid for this lot.</b>
            </h5>
            <br />
            <div className={classes["chat"]}>
              <PopupWidget
                onClose={(e) => {
                  setShow(false);
                  Axios.put(`${Urls.auction}`, {
                    auction_id: auctionDetails?.auction_id,
                    transporter_id: transporterInfo?.transporter_id,
                    transporter_name: transporterInfo?.transporter_name,
                    read_status: true,
                  })
                    .then((res) => {})
                    .catch((err) => {
                      console.log(err);
                    });
                }}
                buttonLabel={<>Chat</>}
                buttonclassName={`btn btn-sm ${classes[buttonClassName]}`}
                modalTitle={auctionDetails?.auction_description}
                content={
                  <AuctionChat
                    fulldata={auctionDetails}
                    auction_id={auctionDetails?.auction_id}
                    transporter_id={transporterInfo?.transporter_id}
                    transporter_name={transporterInfo?.transporter_name}
                    buttonClassName={setButtonClassName}
                    connection_msg={connection_msg_list}
                    auctionClosedStatus={auctionClosed}
                  />
                }
                screen={`Auction`}
              />
            </div>
            <button
              onClick={() => {
                exitAuction(true);
              }}
              className={`${classes["exit-button"]} btn`}
            >
              Go Back to Auction Summary
            </button>
          </div>
        </div>
      ) : null}
      {auctionpaused ? (
        <div className={classes["main-block"]}>
          <div id={"blocked-popup"} className={classes["block"]}>
            {/* <h4><b>Sorry.</b></h4> */}
            <br />
            <h5>
              <b>
                This Auction is paused. Please wait until the further updates.
              </b>
            </h5>
            <div className={classes["paused_popup"]}>
              <div className={classes["chat"]}>
                <PopupWidget
                  onClose={(e) => {
                    setShow(false);
                    // setButtonClassName(`${classes["bg-colo"]}`)
                    Axios.put(`${Urls.auction}`, {
                      auction_id: auctionDetails?.auction_id,
                      transporter_id: transporterInfo?.transporter_id,
                      transporter_name: transporterInfo?.transporter_name,
                      read_status: true,
                    })
                      .then((res) => {
                        //  setReceive(false)
                        //  setShowStatus(false)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                  buttonLabel={<>Chat</>}
                  buttonclassName={`btn btn-sm ${classes[buttonClassName]}`}
                  modalTitle={auctionDetails?.auction_description}
                  content={
                    <AuctionChat
                      fulldata={auctionDetails}
                      auction_id={auctionDetails?.auction_id}
                      transporter_id={transporterInfo?.transporter_id}
                      transporter_name={transporterInfo?.transporter_name}
                      buttonClassName={setButtonClassName}
                      connection_msg={connection_msg_list}
                      auctionClosedStatus={auctionClosed}
                    />
                  }
                  screen={`Truck Availability`}
                />
              </div>
            </div>
            <button
              onClick={() => {
                exitAuction(true);
              }}
              className={`${classes["exit-button"]} btn`}
            >
              Go Back to Auction Summary
            </button>
          </div>
        </div>
      ) : null}

      <div className={classes["header"]}>
        <h3>{auctionDetails?.auction_description}</h3>
        {auctionDetails?.zone ? (
          <h5
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: "13px",
              fontWeight: "700",
              color: "#727271",
            }}
          >
            Zone: {titleCase(auctionDetails?.zone)}
          </h5>
        ) : (
          ""
        )}
      </div>
      <div className={classes["Bidding-Body"]}>
        <div className={classes["timer-quote"]}>
          {/* <button className={`btn ${classes['Timer-Button']}`}>
                        <i style={{ fontSize: "2em" }} className="fa fa-clock"></i> */}
          {auctionClosed ? (
            <RemainingTime status="closed" />
          ) : // auctionpaused ?
          // <RemainingTime status="paused" />
          // :
          reload_timer ? (
            <>
              <RemainingTime
                setStarttime={setStarttime}
                paused_timestamp={paused_timestamp}
                auction_paused={auctionpaused}
                auctionDetails={auctionDetails}
                screen="auction"
                starttime={starttime}
                date={TimerDate}
                status={auctionDetails?.auction_status}
                offset={offset}
                id={location.state.auction_id}
                timerKey={timerKey}
                setTimerKey={setTimerKey}
                setauctionClosed={setauctionClosed}
                setAuctionpaused={setAuctionpaused}
                setreload_timer={setreload_timer}
                reload_timer={reload_timer}
                setpaused_timestamp={setpaused_timestamp}
                getAuctionDetails={getAuctionDetails}
                bucket={location.state.bucket}
                setOffset={setOffset}
              />
            </>
          ) : (
            <RemainingTime
              setStarttime={setStarttime}
              paused_timestamp={paused_timestamp}
              auction_paused={auctionpaused}
              auctionDetails={auctionDetails}
              screen="auction"
              starttime={starttime}
              date={TimerDate}
              status={auctionDetails?.auction_status}
              offset={offset}
              id={location.state.auction_id}
              setauctionClosed={setauctionClosed}
              setAuctionpaused={setAuctionpaused}
              setreload_timer={setreload_timer}
              timerKey={timerKey}
              setTimerKey={setTimerKey}
              reload_timer={reload_timer}
              setpaused_timestamp={setpaused_timestamp}
              getAuctionDetails={getAuctionDetails}
              bucket={location.state.bucket}
            />
          )}
          {/* </button> */}
        </div>

        <div className={classes["Action-Container"]}>
          {!isMobile() ? (
            <table className={classes["auction-table"]}>
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>Auction ID</th>
                  {/**width='80' style={{ paddingLeft: '1%' }} */}
                  <th style={{ width: "8%" }}>Volume/ Quantity</th>
                  {/**width='80' style={{ paddingLeft: '1%', textAlign:'center' }} */}
                  <th style={{ width: "10%" }}>Opening Price</th>{" "}
                  {/**style={{ width: '10%', paddingLeft: '1%' }} */}
                  <th style={{ width: "10%" }}>Bid Decrement</th>{" "}
                  {/**style={{ width: '12%' }} */}
                  <th style={{ width: "10%" }}>My Bid</th>{" "}
                  {/**style={{ width: '7%' }} */}
                  <th style={{ width: "10%" }}>L1 Quote</th>{" "}
                  {/**style={{ width: '12%' }} */}
                  <th style={{ width: "15%" }}>Bid Amount</th>
                  <th style={{ width: "6%" }}>My Rank</th>
                  <th style={{ width: "10%" }}>My Last Bid Status</th>
                  <th style={{ width: "15%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {auctionDetails ? (
                  <>
                    <tr height="100">
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        {auctionDetails?.display_id}
                      </td>{" "}
                      {/**width='80' style={{ paddingLeft: '1%', fontSize: '14px' }} */}
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        {auctionDetails?.unit_metric}
                      </td>{" "}
                      {/**width='80' style={{ paddingLeft: '1%', fontSize: '14px', textAlign:'center' }} */}
                      <td>
                        <input
                          className={classes["bid-box"]}
                          value={numberWithCommas(
                            auctionDetails?.starting_amount
                          )}
                        />
                      </td>{" "}
                      {/** className={classes['Bid-Box9']} */}
                      <td>
                        <input
                          className={classes["bid-box"]}
                          value={numberWithCommas(
                            auctionDetails?.bid_decrement_amount
                          )}
                        />
                      </td>
                      {/**className={classes['Bid-Box2']} */}
                      <td>
                        <input
                          className={classes["bid-box"]}
                          value={numberWithCommas(myBid)}
                        />
                      </td>{" "}
                      {/* {finalOffer === true ? <i className="fa fa-tag"></i> : null} */}
                      {/** className={classes['Bid-Box4']} */}
                      {/* <td ><input className={classes['bid-box']} value={'-'} /></td> */}
                      <td>
                        <input
                          className={classes["bid-box3"]}
                          value={numberWithCommas(L1_Quote)}
                        />
                      </td>
                      <td style={{ width: "17%", textAlign: "center" }}>
                        {/**width='210' style={{ textAlign: 'end' }} */}
                        {auctionClosed || showBlocked ? (
                          <>
                            <button
                              disabled
                              onClick={(e) => BidDecrement()}
                              className={classes["Increment-Button-Disabled"]}
                            >
                              <i
                                style={{
                                  cursor: "no-drop",
                                  color: "white",
                                  backgroundColor: "#393186",
                                }}
                                className="fas fa-minus-square"
                              ></i>
                            </button>
                            <input
                              style={{ cursor: "no-drop" }}
                              className={classes["Bid-Amount"]}
                              value={numberWithCommas(bidAmount)}
                            />
                            <button
                              disabled
                              onClick={(e) => BidIncrement()}
                              className={classes["Increment-Button-Disabled"]}
                            >
                              <i
                                style={{
                                  cursor: "no-drop",
                                  color: "white",
                                  backgroundColor: "#393186",
                                }}
                                className="fas fa-plus-square"
                              ></i>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={(e) => BidDecrement()}
                              className={classes["Increment-Button"]}
                            >
                              <i
                                style={{
                                  cursor: "pointer",
                                  color: "white",
                                  backgroundColor: "#393186",
                                }}
                                className="fas fa-minus-square"
                              ></i>
                            </button>
                            <input
                              className={classes["Bid-Amount"]}
                              value={numberWithCommas(bidAmount)}
                            />
                            <button
                              onClick={(e) => BidIncrement()}
                              className={classes["Increment-Button"]}
                            >
                              <i
                                style={{
                                  cursor: "pointer",
                                  color: "white",
                                  backgroundColor: "#393186",
                                }}
                                className="fas fa-plus-square"
                              ></i>
                            </button>
                          </>
                        )}
                      </td>
                      <td style={{ fontSize: "large", textAlign: "center" }}>
                        {" "}
                        {/**style={{ paddingLeft: '3%', fontSize: 'large' }} */}
                        {rank !== "" ? (
                          rank === 1 ? (
                            <>
                              <button className={classes["RankGreenButton"]}>
                                <b>L {rank}</b>
                              </button>
                            </>
                          ) : (
                            <>
                              {rank === 2 ? (
                                <button className={classes["RankYellowButton"]}>
                                  <b>L {rank}</b>
                                </button>
                              ) : (
                                <button className={classes["RankRedButton"]}>
                                  <b>L {rank}</b>
                                </button>
                              )}
                            </>
                          )
                        ) : null}
                        {/* {rank} */}
                      </td>
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        {Bid_updated === "YES" ? (
                          <span
                            style={{
                              color: "green",
                              paddingRight: "1%",
                              fontSize: "13px",
                            }}
                          >
                            Bid Accepted
                          </span>
                        ) : Bid_updated === "NO" ? (
                          <span
                            style={{
                              color: "red",
                              paddingRight: "1%",
                              fontSize: "13px",
                            }}
                          >
                            Bid Rejected
                          </span>
                        ) : (
                          <span style={{ paddingRight: "1%" }}>-</span>
                        )}{" "}
                      </td>{" "}
                      {/**style={{ textAlign: 'center' }} */}
                      <td
                        style={{
                          textAlign: "center",
                          display: "flex",
                          marginTop: "20%",
                          marginLeft: auctionDetails?.final_offer === true ? "2%" : "30%",
                        }}
                      >
                        <button
                          disabled={
                            transporterAccess===false || 
                            auctionClosed || auctionpaused || showBlocked
                          }
                          onClick={() => submitHandler(false)}
                          className="btn btn-sm btn-success"
                        >
                          Submit
                        </button>
                      {auctionDetails?.final_offer === true ?
                        <button disabled={transporterAccess===false || auctionClosed || auctionpaused || showBlocked }
                          onClick={() => submitHandler(true)} style={{marginLeft: '5%', backgroundColor: '#393185'}}
                          className="btn btn-sm btn-primary"
                        >
                          Final Offer
                        </button>: null}
                      </td> 
                    </tr>
                  </>
                ) : null}
              </tbody>
            </table>
          ) : (
            <>
              <div className={classes["auction-table"]}>
                <div>
                  {auctionDetails ? (
                    <>
                      <div height="100" className="pl-3 pt-3 pb-3">
                        <div
                          style={{
                            fontSize: "14px",
                            display:"flex"
                          }}
                        >
                          <b style={{width:"40%"}}>Auction ID:</b>
                          {auctionDetails?.display_id}
                        </div>
                        <div style={{ display: "flex" }}>
                          <b style={{ width: "40%" }}>Total Unit Metric:</b>
                          {auctionDetails?.unit_metric}
                        </div>
                        <div style={{ display: "flex" }}>
                          <b style={{ width: "30%" }}>Opening Price:</b>
                          <input
                            className={classes["Bid-Box1"]}
                            value={numberWithCommas(
                              auctionDetails?.starting_amount
                            )}
                          />
                        </div>
                        <div style={{ display: "flex" }}>
                          <b style={{ width: "30%" }}>Bid Decrement:</b>
                          <input
                            className={classes["Bid-Box1"]}
                            value={numberWithCommas(
                              auctionDetails?.bid_decrement_amount
                            )}
                          />
                        </div>
                        <div style={{ display: "flex" }}>
                          <b style={{ width: "30%" }}>My Bid:</b>
                          <input
                            className={classes["Bid-Box1"]}
                            value={numberWithCommas(myBid)}
                          />
                        </div>
                        {/* <div style={{display:'flex'}}><b style={{width:'25%'}}>L1 Quote:</b><input className={classes['Bid-Box1']} value={'-'} /></div> */}
                        <div style={{ display: "flex" }}>
                          <b style={{ width: "30%" }}>L1 Quote:</b>
                          <input
                            className={classes["Bid-Box1"]}
                            value={numberWithCommas(L1_Quote)}
                          />
                        </div>
                        <div className="mt-4" style={{ display: "flex" }}>
                          <b style={{ width: "30%" }}>Bid Amount:</b>
                          <div style={{ marginLeft: "9%", display:"flex" }}>
                            {auctionClosed ? (
                              <>
                                <button
                                  disabled
                                  onClick={(e) => BidDecrement()}
                                  className={
                                    classes["Increment-Button-Disabled"]
                                  }
                                >
                                  <i
                                    style={{
                                      cursor: "no-drop",
                                      color: "white",
                                      backgroundColor: "#393186",
                                    }}
                                    className="fas fa-minus-square"
                                  ></i>
                                </button>
                                <input
                                  style={{ cursor: "no-drop" }}
                                  className={classes["Bid-Amount"]}
                                  value={numberWithCommas(bidAmount)}
                                />
                                <button
                                  disabled
                                  onClick={(e) => BidIncrement()}
                                  className={
                                    classes["Increment-Button-Disabled"]
                                  }
                                >
                                  <i
                                    style={{
                                      cursor: "no-drop",
                                      color: "white",
                                      backgroundColor: "#393186",
                                    }}
                                    className="fas fa-plus-square"
                                  ></i>
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  onClick={(e) => BidDecrement()}
                                  className={classes["Increment-Button"]}
                                >
                                  <i
                                    style={{
                                      cursor: "pointer",
                                      color: "white",
                                      backgroundColor: "#393186",
                                    }}
                                    className="fas fa-minus-square"
                                  ></i>
                                </button>
                                <input
                                  className={classes["Bid-Amount"]}
                                  value={numberWithCommas(bidAmount)}
                                />
                                <button
                                  onClick={(e) => BidIncrement()}
                                  className={classes["Increment-Button"]}
                                >
                                  <i
                                    style={{
                                      cursor: "pointer",
                                      color: "white",
                                      backgroundColor: "#393186",
                                    }}
                                    className="fas fa-plus-square"
                                  ></i>
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "6% 0%",
                            display: "flex",
                            fontSize: "14px",
                          }}
                        >
                          <b style={{ width: "30%" }}>My Rank:</b>
                          <div style={{ marginLeft: "9%" }}></div>
                          {rank !== "" ? (
                            rank === 1 ? (
                              <>
                                <button className={classes["RankGreenButton"]}>
                                  <b>L {rank}</b>
                                </button>
                              </>
                            ) : (
                              <>
                                {rank === 2 ? (
                                  <button
                                    className={classes["RankYellowButton"]}
                                  >
                                    <b>L {rank}</b>
                                  </button>
                                ) : (
                                  <button className={classes["RankRedButton"]}>
                                    <b>L {rank}</b>
                                  </button>
                                )}
                              </>
                            )
                          ) : null}
                        </div>
                        {/* style={{ textAlign: 'center' }} */}
                        <div className="mb-3">
                          <b style={{ marginRight: "2%", width: "30%" }}>
                            My Last Bid Status:{" "}
                          </b>
                          {Bid_updated === "YES" ? (
                            <span
                              style={{
                                color: "green",
                                paddingRight: "1%",
                                fontSize: "15px",
                              }}
                            >
                              Bid Accepted
                            </span>
                          ) : Bid_updated === "NO" ? (
                            <span
                              style={{
                                color: "red",
                                paddingRight: "1%",
                                fontSize: "15px",
                              }}
                            >
                              Bid Rejected
                            </span>
                          ) : (
                            <span style={{ paddingRight: "1%" }}>-</span>
                          )}{" "}
                        </div>
                        <center>
                          <button
                            disabled={
                              transporterAccess===false ||
                              auctionClosed || auctionpaused || showBlocked
                            }
                            onClick={() => submitHandler(false)}
                            className="btn btn-sm btn-success"
                          >
                            Submit
                          </button>
                          {auctionDetails?.final_offer === true ? (
                            <button
                              disabled={
                                transporterAccess===false ||
                                auctionClosed || auctionpaused || showBlocked
                              }
                              onClick={() => submitHandler(true)}
                              className="btn btn-sm btn-primary ml-3"
                            >
                              Final Offer
                            </button>
                          ) : null}
                        </center>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "25px" }}
        className={classes["footer"]}
      >
        <div className={classes["chat"]}>
          <PopupWidget
            onClose={(e) => {
              setShow(false);
              // setButtonClassName(`${classes["bg-colo"]}`)
              Axios.put(`${Urls.auction}`, {
                auction_id: auctionDetails?.auction_id,
                transporter_id: transporterInfo?.transporter_id,
                transporter_name: transporterInfo?.transporter_name,
                read_status: true,
              })
                .then((res) => {})
                .catch((err) => {
                  console.log(err);
                });
            }}
            buttonLabel={<>Chat</>}
            buttonclassName={`btn ${classes[buttonClassName]}`}
            modalTitle={auctionDetails?.auction_description}
            content={
              <AuctionChat
                fulldata={auctionDetails}
                auction_id={auctionDetails?.auction_id}
                transporter_id={transporterInfo?.transporter_id}
                transporter_name={transporterInfo?.transporter_name}
                connection_msg={connection_msg_list}
                buttonClassName={setButtonClassName}
                // auctionClosedStatus={auctionClosed}
              />
            }
            disabled={auctionClosed}
            screen={`Truck Availability`}
          />
        </div>
        <div style={{ paddingTop: "2px" }}>
          <button
            onClick={() => {
              exitAuction(false);
            }}
            className={`${classes["exit-button"]} btn`}
          >
            Go Back to Auction Summary
          </button>
        </div>
      </div>

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={resetConfirmDialog}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        variant={confirmDialog.variant}
        disableButton={confirmDialog.disableButton}
      />
    </div>
  );
};

export default BiddingScreen;
